import { render, staticRenderFns } from "./couponPanel.vue?vue&type=template&id=122a40ca&scoped=true&"
import script from "./couponPanel.vue?vue&type=script&lang=js&"
export * from "./couponPanel.vue?vue&type=script&lang=js&"
import style0 from "./couponPanel.vue?vue&type=style&index=0&id=122a40ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122a40ca",
  null
  
)

export default component.exports